import { render } from "./GooglePlayButton.vue?vue&type=template&id=9f1270c8&scoped=true"
import script from "./GooglePlayButton.vue?vue&type=script&lang=js"
export * from "./GooglePlayButton.vue?vue&type=script&lang=js"

import "./GooglePlayButton.vue?vue&type=style&index=0&id=9f1270c8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f1270c8"]])

export default __exports__